import { formatNumberAsThousands } from 'utils/priceHelpers'

import styles from './InsightsTooltip.module.scss'

const TooltipRow = props => {
  const { value, name, unit, fontSize, valueFormatter } = props

  return (
    <div className={styles.tooltipRow} style={{ fontSize }}>
      <span className={styles.tooltipLabel}>{name}</span> {unit === '$' ? unit : ''}
      <span className={styles.tooltipValue}>
        {valueFormatter(value)} {unit !== '$' ? unit : ''}
      </span>
    </div>
  )
}

const InsightsTooltip = ({
  label,
  payload,
  fontSize = 12,
  labelFormatter,
  valueFormatter = formatNumberAsThousands,
  dataTitle
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.tooltipTitle}>
        {labelFormatter ? labelFormatter(label) : label}
      </div>
      {payload?.map((p, i) => (
        <TooltipRow
          {...p}
          key={`${p.name}${i}`}
          fontSize={fontSize}
          name={dataTitle}
          valueFormatter={valueFormatter}
        />
      ))}
    </div>
  )
}

export default InsightsTooltip
